// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"c5ea55bc","472":"018de8e6"}[chunkId] + ".chunk.js";
};